import React from 'react'
import PropTypes from 'prop-types'
import Countdown from 'react-countdown'

import {
  CountdownWrapper,
  CountdownColumn,
  Text,
  Link,
  SmallText,
  Time,
} from './styles'
import plansMeta from '../../constants/plans'
import { countdownContent } from './CountdownContent'

const CountdownBanner = ({ planName, voucherExpiryDate }) => {
  const planMeta = Object.values(plansMeta).filter(
    (value) => value.name === planName
  )
  const { slug, color } = planMeta[0]

  return (
    <Link href={`https://smarty.co.uk/order/${slug}`}>
      <CountdownWrapper backgroundColor={color}>
        <CountdownColumn>
          <Text>{planName} offer ends in </Text>
        </CountdownColumn>
        <CountdownColumn withNumbers>
          {countdownContent.durations.map((d) => (
            <Time key={d.time}>
              <Countdown
                date={voucherExpiryDate}
                renderer={(props) => (
                  <>
                    <Text>{`${props[d.time]}`}</Text>
                    <SmallText>{d.text_to_display}</SmallText>
                  </>
                )}
              />
            </Time>
          ))}
        </CountdownColumn>
      </CountdownWrapper>
    </Link>
  )
}

CountdownBanner.propTypes = {
  planName: PropTypes.string.isRequired,
  voucherExpiryDate: PropTypes.instanceOf(Date).isRequired,
}

export default CountdownBanner
